<div class="content">
  <div class="login">
    <div class="login-logo">
      <img src="../assets/images/logo.png">
    </div>
    <form [formGroup]="form" (ngSubmit)="login()" novalidate>
      <div class="login-content">
        <h3 translate>Sign in to PowerPanel Cloud</h3>
        <p-message severity="error" icon="pi pi-times-circle" text="Login fail." *ngIf="loginFail"></p-message>
        <p-message severity="error" icon="pi pi-times-circle" text="reCAPTCHA fail. Please try again" *ngIf="reCAPTCHAFail"></p-message>

        <div class="form-group">
          <label translate for="" class="col-form-label">Username</label>
          <div>
            <input type="text" pInputText id="username" class="pInputText" formControlName="username" required>
          </div>
        </div>
        <div class="form-group">
          <label translate for="" class="col-form-label">Password</label>
          <div class="inputpassword">
            <!-- <input type="password" pPassword id="password" class="pInputText" formControlName="password" required> -->
            <!-- <input type="{{inputType}}" pPassword id="password" class="pInputText" formControlName="password" required (ngModelChange)="passwordChange(password.value)" autocomplete="off">
            <p-toggleButton class="passwordIcon" onIcon="pi pi-eye" offIcon="pi pi-eye-slash" onLabel="pi-eye" offLabel="pi-eye" (onChange)="handleChange($event)" *ngIf="showPasswordIcon"></p-toggleButton> -->

            <p-password formControlName="password" id="password" required [toggleMask]="true" autocomplete="off" />
          </div>
        </div>
        <!-- <div class="g-recaptcha" data-sitekey="6LfDj0krAAAAAD9KlrtOfpP1Ixs6gQ1fQZE9CdSk" data-callback="captchaHandler" data-size="invisible"></div> -->
        <div class="link">
          <a translate href="/resend-activation-mail" class="resend">Resend Activation Mail</a>
          <a translate href="{{ ForgetPasswordUrl }}" class="password" target="_blank">Forget password ?</a>
        </div>

        <button id="loginButton" type="submit" pButton label="{{'LOG IN' | translate}}" class="ui-button-danger login-btn" [disabled]="isLogging" (click)="countdown.restart();"></button>
        <div class="demo">
          <a translate href="{{ DemoUrl }}" class="outline" target="_blank">Try Demo</a>
        </div>
        <div class="social-accounts" *ngIf="!isProd">
          <p class="social-separator" translate>Or</p>
          <div class="social-list">
            <div class="p-button-rounded social-icon" (click)="socialLogin('apple');">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x apple"></i>
                <i class="fa fa-apple fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            <div class="p-button-rounded social-icon" (click)="socialLogin('google');">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x google"></i>
                <i class="fa fa-google fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            <!-- 2026/07/21 kyrie.hung 移除 Facebook 登入功能
            <div class="ui-button-rounded social-icon" (click)="socialLogin('facebook');">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x facebook"></i>
                <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
              </span>
            </div>
            -->
          </div>
        </div>
        <div class="sign">
          {{"Don't have an account?" | translate: {Default: "Don't have an account?"} }}
          <a translate href="{{ RegisterUrl }}" class="" target="_blank"> Sign Up</a>
        </div>
      </div>
    </form>
    <div class="bg-white padding-15 border-top-16 text-center">
      <button pButton label="Login with SSO" (click)="routerSSO();" severity="primary"></button>
    </div>
    <div class="system-version"><small>v</small>{{WebVersion}}</div>
  </div>
</div>

<!-- 登入失敗多次後鎖定帳號 -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="LoginLocked" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5>{{LoginLockedMessage | translate}}</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>


<!-- AFG被綁定 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialAccountCombineLimitAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>You have used the other social account to combine with the PowerPanel Cloud account.</p>
      <p translate>Please log in to your PowerPanel Cloud account and cancel the combination first if you want to combine this social account with the PowerPanel Cloud account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="{{Confirm_button}}" (click)="socialAccountCombineLimitAlert=false"></button>
  </ng-template>
</p-dialog>

<!-- Email被綁定 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialAccountEmailAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{'The e-mail address censoredEmail has alrady been registered for an PowerPanel Cloud account._1' | translate}} <span class="strong">{{censoredEmail}}</span> {{'The e-mail address censoredEmail has alrady been registered for an PowerPanel Cloud account._2' | translate}} </p>
      <p translate>Please log in to your PowerPanel Cloud account and go to Account page to combine the social account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="{{Confirm_button}}" (click)="socialAccountEmailAlert=false"></button>
  </ng-template>
</p-dialog>

<!-- system詢問user:有沒有用其它e-mail註冊過PPC服務 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialEmailRegisterAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5 translate>Have you used the other e-mail address to register for CyberPower Account before?</h5>
      <p translate>If yes, please log in to your PowerPanel Cloud account and go to Account page to combine the social account.</p>
      <p translate>If no, please click "No" and a new PowerPanel Cloud account will be created.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Yes' | translate}}" (click)="registerAccountWithOtherMail();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'No' | translate}}" (click)="registerAccountWithSocial();" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system詢問user:有沒有用其它e-mail註冊過PPC服務 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="socialEmailRegisterSetting" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content flex-none">
    <div class="form-group">
      <label for="" class="col-form-label" translate>Please select your location</label>
      <div class="select">
        <p-select [options]="CountryOptions" [(ngModel)]="Country" name="Country" #country="ngModel" required appendTo="body"></p-select>
      </div>
    </div>
    <div translate class="alert alert-warning">
      The registration process will be terminated if you click cancel now.
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="registerAccountSettingSave();" class="{{Confirm_button}}" [disabled]="checkRegisterAccountSave()"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="socialEmailRegisterSetting=false" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- system跳視窗請user輸入OTP -->
<p-dialog header="{{'Two-Factor Authentication' | translate}}" [(visible)]="TwoFactorAuthDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="true" (onHide)="closeDialog()">
  <div class="dialog-content">
    <div class="content-info center auth">
      <span class="fa-stack fa-lg">
        <span class="material-icons fa-stack-2x shield">
          shield
        </span>
        <span class="material-icons fa-stack-1x key">
          key
        </span>
      </span>
      <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
      <p-inputMask mask="999999" [(ngModel)]="OTPNumber" [ngClass]="{'ng-validDirty': dialogSaveDirty}" [disabled]="OTPOvertime" (keyup.enter)="OTPkeyupEnter($event);" (ngModelChange)="OTPNumberOnchange($event)"></p-inputMask>
      <p-message severity="error" *ngIf="dialogSaveDirty"></p-message>
      <p [ngClass]="{'message-error': OTPOvertime}">
        <span *ngIf="OTPOvertime else OTPOvertimeTrue">{{errorMsg | translate}} <br><span *ngIf="errorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
        <span class="time">
          <countdown #countdown [config]="config" (event)="handleEvent($event)"></countdown>
        </span>
      </p>
      <ng-template #OTPOvertimeTrue>
        <p style="color:red;font-weight: bolder;">{{errorMsg | translate}}</p>
        <p translate>OTP will expire in</p>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Submit' | translate}}" (click)="confrimOTPnumber();" class="{{Confirm_button}}" *ngIf="!OTPOvertime" [disabled]="OTPNumberSubmitDisabled"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="OTPOvertime"></button>
  </ng-template>
</p-dialog>

<!-- OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="OTPLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

